export const singleUserIcon = [
  "24 24",
  `
    <path xmlns="http://www.w3.org/2000/svg" fill="none" stroke="" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20,21v-2
	c0-2.209-1.791-4-4-4H8c-2.209,0-4,1.791-4,4v2 M12,3c2.209,0,4,1.791,4,4s-1.791,4-4,4S8,9.209,8,7S9.791,3,12,3z"/>
      `,
];
